'use client';

import React from 'react';
import { CanLogoIcon } from '../../../../../public/assets/icons';
import { Box, Text } from '@chakra-ui/react';
import { PaymentProps } from './types/template.types';
import PaymentForm from '../forms/payment/PaymentForm';
import Wrapper from '@/app/_providers/StripeProvider';

const Payment = ({ previous }: PaymentProps) => {
   return (
      <>
         <Box minH="72px">
            <CanLogoIcon />
         </Box>
         <Text
            as="h2"
            color="white"
            fontSize={{ base: '4xl', sm: '5xl', md: '12xl' }}
            fontWeight="bold"
            textAlign="center"
         >
            CANCARD<sup style={{ fontSize: '0.7em', fontWeight: '400' }}>™</sup> PAYMENT
         </Text>
         <Text color="white" textStyle="md" textAlign="center" mt="-10px" mb="2">
            To finalise your Cancard purchase, please use a<br /> valid credit card for payment.
         </Text>
         <Wrapper>
            <PaymentForm previous={previous} />
         </Wrapper>
      </>
   );
};

export default Payment;
